import { AGGREGATOR_BASE_URL } from 'src/environments/base-url';

export const searchAggregatorProviderGames = (regionId: number, providerId: string): string =>
  `${AGGREGATOR_BASE_URL}/regions/${regionId}/providers/${providerId}/games/search`;
